import { createContext, useContext, useEffect, useState } from "react";
import { useApp } from "@/context/AppContext";
import * as M from "@/lib/mockData";

const StoreContext = createContext(null);
const KEY = "novus_db_v1";

function initialDb() {
  return {
    patients: M.PATIENTS,
    orders: M.ORDERS,
    specimens: M.SPECIMENS,
    aliquots: M.ALIQUOTS,
    results: M.RESULTS,
    reports: M.REPORTS,
    criticalAlerts: M.CRITICAL_ALERTS,
    leads: M.LEADS,
    hcBookings: M.HC_BOOKINGS,
    executives: M.EXECUTIVES,
    zones: M.ZONES,
    payments: M.PAYMENTS,
    expenses: M.EXPENSES,
    dayClosing: M.DAY_CLOSING,
    departments: M.DEPARTMENT_MASTER,
    tests: M.TESTS,
    packages: M.PACKAGES,
    testParameters: M.TEST_PARAMETERS,
    walletTxns: M.WALLET_TXNS,
    referrals: M.REFERRALS,
    vouchers: M.GIFT_VOUCHERS,
    tariff: M.TARIFF_MATRIX,
    priceHistory: M.PRICE_HISTORY,
    users: M.USERS,
    corporates: M.CORPORATES,
    radiology: M.RADIOLOGY_PARTNERS,
    franchises: M.FRANCHISES,
    doctors: M.DOCTORS,
    capa: M.CAPA,
    inventory: M.INVENTORY,
    auditTrail: M.AUDIT_TRAIL,
  };
}

export function StoreProvider({ children }) {
  const { session } = useApp();
  const [db, setDb] = useState(() => {
    try {
      const raw = localStorage.getItem(KEY);
      return raw ? { ...initialDb(), ...JSON.parse(raw) } : initialDb();
    } catch {
      return initialDb();
    }
  });

  useEffect(() => {
    try { localStorage.setItem(KEY, JSON.stringify(db)); } catch {}
  }, [db]);

  const update = (key, updater) =>
    setDb((prev) => ({
      ...prev,
      [key]: typeof updater === "function" ? updater(prev[key]) : updater,
    }));

  const now = () => {
    const d = new Date();
    return d.toLocaleString("en-IN", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit", hour12: false });
  };

  const logAudit = (action, entity, oldVal = "—", newVal = "—") =>
    update("auditTrail", (a) => [
      { time: now(), user: session?.name || "System", action, entity, oldVal: String(oldVal), newVal: String(newVal), ip: "10.2.1." + (Math.floor(Math.random() * 90) + 10) },
      ...a,
    ]);

  const genId = (prefix, len = 4) =>
    `${prefix}${String(Math.floor(Math.random() * 9000) + 1000).slice(0, len)}`;

  const resetDb = () => setDb(initialDb());

  return (
    <StoreContext.Provider value={{ db, update, logAudit, genId, now, resetDb }}>
      {children}
    </StoreContext.Provider>
  );
}

export const useStore = () => useContext(StoreContext);
